import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { default as DefaultIcon } from './Icon';
import IconGradient from './IconGradient';

const Icon = memo(({ hasGradient, ...props }) =>
    hasGradient ? <IconGradient {...props} /> : <DefaultIcon {...props} />,
);

Icon.displayName = 'Icon';

Icon.propTypes = {
    /** Custom className for styling purposes */
    className: PropTypes.string,
    /** Object with custom style overrides for inner elements */
    overrides: PropTypes.object,
    /** Size variant of the icon */
    size: PropTypes.oneOf(['raw', 'small', 'smallMedium', 'medium', 'large', 'big', 'huge']),
    /** Name of the icon to display from the icon library */
    name: PropTypes.string,
    /** Color of the icon (hex, RGB, or color name) */
    color: PropTypes.string,
    /** Secondary color for dual-color icons */
    color2: PropTypes.string,
    /** Function called when the icon is clicked */
    onClick: PropTypes.func,
    /** Text to show in a tooltip when hovering over the icon */
    tooltip: PropTypes.node,
    /** Position of the tooltip relative to the icon */
    placement: PropTypes.oneOf([
        'top',
        'topLeft',
        'topRight',
        'bottom',
        'bottomLeft',
        'bottomRight',
        'left',
        'leftTop',
        'leftBottom',
        'right',
        'rightTop',
        'rightBottom',
    ]),
    /** Name of the icon to display when hovering over the primary icon */
    nameOver: PropTypes.string,
    /** When true, renders the icon with a gradient fill instead of solid color */
    hasGradient: PropTypes.bool,
    /** Array of gradient color stops (only used when hasGradient is true) */
    gradientStops: PropTypes.arrayOf(
        PropTypes.shape({
            /** Percentage position of the color stop (e.g., '0%', '100%') */
            offset: PropTypes.string,
            /** Color value at this stop */
            color: PropTypes.string,
        }),
    ),
};

export default Icon;
